import { Routes } from '@angular/router';
import { HomeComponent } from './app/pages/home/home.component';
import { AboutComponent } from './app/pages/about/about.component';
import { TeamComponent } from './app/pages/team/team.component';
import { ApplicationsComponent } from './app/pages/applications/applications.component';
import { CommunityComponent } from './app/pages/community/community.component';
import { DonationsComponent } from './app/pages/donations/donations.component';
import { AdminPortalComponent } from './app/components/admin-portal/admin-portal.component';
import { roleGuard } from './app/auth/role.guard';
import { WhitelistPageComponent } from './app/components/whitelist-page/whitelist-page.component';
import { TermsPrivacyComponent } from './app/pages/terms-privacy/terms-privacy.component';
import { ContactUsComponent } from './app/pages/contact-us/contact-us.component';

export const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'aboutUs', component: AboutComponent },
  { path: 'team', component: TeamComponent },
  { path: 'applications', component: ApplicationsComponent },
  { path: 'community', component: CommunityComponent },
  { path: 'donations', component: DonationsComponent },
  { path: 'contact-us', component: ContactUsComponent },
  {
    path: 'crew',
    component: WhitelistPageComponent,
    canActivate: [roleGuard],
    data: {
      role: 'Crew',
      portalType: 'Crew'
    }
  },
  {
    path: 'manager',
    component: WhitelistPageComponent,
    canActivate: [roleGuard],
    data: {
      role: 'Manager',
      portalType: 'Manager'
    }
  },
  {
    path: 'admin',
    component: AdminPortalComponent,
    canActivate: [roleGuard],
    data: { role: 'Admin' }
  },
  {
    path: 'terms-privacy',
    component: TermsPrivacyComponent,
  },
];